<template>
  <div class="row">
    <div class="flex xs12">
      <va-card :title="inviterPage?'邀请列表':'用户'">
        <div class="row align--center mb-1">
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter({})">总用户: {{allCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter({subscriptionStatus: 3})">basic付费用户: {{basicChargeCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter({subscriptionStatus: 1})">pro付费用户: {{proChargeCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat color="danger" v-on:click="applyFilter({subscriptionStatus: 2})">学员: {{xueYuanCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat style="color: #ff8c00;" v-on:click="applyFilter({cancelLabel: 1})">试用期取消: {{trialCanceledCount}}</va-button>
          </div>
          <div class="flex md2 xs12">
            <va-button flat style="color: #9932cc;" v-on:click="applyFilter({cancelLabel: 2})">不续费取消: {{paidCanceledCount}}</va-button>
          </div>
        </div>

        <div class="flex md4 xs12">
          <va-input
            class="ma-0"
            :value="keyword"
            placeholder="按用户名或邮箱搜索"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend"/>
          </va-input>
        </div>

        <div class="flex md4 xs12">
          <va-date-picker
            label="按注册时间搜索"
            :config="{mode: 'range'}"
            v-model="dateTime"
            @input="searchByDate"
          />
        </div>

        <div class="flex md4 xs12">
          <va-button
            color="success"
            :loading="exportLoading"
            @click="exportToCSV"
            icon="fa fa-download"
          >
            导出CSV
          </va-button>
        </div>

        <va-data-table
          class="openjob-user-table"
          :fields="fields"
          :data="jobUsers"
          :loading="loading"
          :totalPages="totalPage"
          @page-selected="listJobUser"
          api-mode
        >
          <template slot="typeSlot" slot-scope="props">
            <va-badge :color="computeStatus(props.rowData.type, props.rowData.renewStatus, props.rowData.subscriptionVersion).color">
              {{ computeStatus(props.rowData.type, props.rowData.renewStatus, props.rowData.subscriptionVersion).text }}
            </va-badge>
          </template>
          <template slot="sourceSlot" slot-scope="props">
            {{ formatSource(props.rowData.source) }}
          </template>
          <template slot="createTime" slot-scope="props">
            {{ formatRegisterTime(props.rowData.createTime) }}
          </template>
          <template slot="period" slot-scope="props">
            {{ formatPeriodTime(props.rowData.startTime, props.rowData.endTime) }}
          </template>
          <template slot="lastPushTime" slot-scope="props">
            {{ formatPushTime(props.rowData.lastPushTime) }}
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getJobUser/${props.rowData.uid}`}'/>
            </va-popover>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>

import { formatTime, parseDate } from '@/utils/common'
import openJobApi from '../../api/openJob'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      message: ['Required field'],
      jobUsers: [],
      loading: true,
      totalCount: 0,
      basicChargeCount: 0,
      proChargeCount: 0,
      xueYuanCount: 0,
      // Autopilot 后端始终统计但 CMS 暂不展示按钮（套餐未上线）;
      // 上线时只需在顶部加按钮 + applyFilter({subscriptionStatus: 4})
      autopilotChargeCount: 0,
      trialCanceledCount: 0,
      paidCanceledCount: 0,
      allCount: 0,
      totalPage: null,
      keyword: null,
      inviterUid: null,
      inviterPage: false,
      dateTime: null,
      startTime: null,
      endTime: null,
      // 当前激活的 filter（subscriptionStatus 与 cancelLabel 互斥）
      currentSubscriptionStatus: null,
      currentCancelLabel: null,
      exportLoading: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'nickname',
          title: '用户名',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '12%',
        },
        {
          name: 'email',
          title: '邮箱',
          titleClass: 'text-center',
          dataClass: 'text-center openjob-user-table__email',
          width: '18%',
        },
        {
          name: '__slot:createTime',
          title: '注册时间',
          titleClass: 'text-center',
          dataClass: 'text-center openjob-user-table__nowrap',
          width: '11%',
        },
        {
          name: '__slot:typeSlot',
          title: '订阅状态',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '11%',
        },
        {
          name: '__slot:sourceSlot',
          title: '用户来源',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '7%',
        },
        {
          name: '__slot:period',
          title: '有效期',
          titleClass: 'text-center',
          dataClass: 'text-center openjob-user-table__nowrap',
          width: '13%',
        },
        {
          name: '__slot:lastPushTime',
          title: '最近推送时间',
          titleClass: 'text-center',
          dataClass: 'text-center openjob-user-table__nowrap',
          width: '11%',
        },
        {
          name: 'sendStatus',
          title: '推送状态',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '6%',
        },
        {
          name: 'matchResult',
          title: '技术指标',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '6%',
        },
        {
          name: '__slot:actions',
          title: '操作',
          titleClass: 'text-center',
          width: '5%',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.inviterUid = this.$route.query.inviterUid
    if (this.inviterUid != null) {
      this.inviterPage = true
    }
    this.listJobUser()
  },
  methods: {
    search: debounce(function (keyword) {
      this.keyword = keyword
      if (this.keyword === '') { this.keyword = null }
      this.listJobUser(1)
    }, 400),
    searchByDate: debounce(function (dateTime) {
      const regex = /^\d{4}-\d{2}-\d{2} to \d{4}-\d{2}-\d{2}$/
      if (!regex.test(dateTime)) {
        return null
      }
      const [startDate, endDate] = dateTime.split(' to ')
      this.startTime = parseDate(startDate)
      this.endTime = parseDate(endDate)
      this.listJobUser(1)
    }, 400),
    /**
     * 切换 filter（按钮回调）。subscriptionStatus 与 cancelLabel 互斥，
     * 任意一个被设置都会清空另一个，与现有"按一个按钮就重置"的交互一致。
     */
    applyFilter ({ subscriptionStatus = null, cancelLabel = null }) {
      this.currentSubscriptionStatus = subscriptionStatus
      this.currentCancelLabel = cancelLabel
      this.listJobUser(1)
    },
    listJobUser (pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 100,
        pageNumber: pageNumber,
        keyword: this.keyword,
        inviterUid: this.inviterUid,
        startTime: this.startTime,
        endTime: this.endTime,
        subscriptionStatus: this.currentSubscriptionStatus,
        cancelLabel: this.currentCancelLabel,
      }
      openJobApi.listUser(data)
        .then(response => {
          this.jobUsers = response.userSimpleInfoList
          this.totalCount = response.totalCount
          this.totalPage = response.totalPage
          this.basicChargeCount = response.basicChargeCount
          this.proChargeCount = response.proChargeCount
          this.autopilotChargeCount = response.autopilotChargeCount || 0
          this.xueYuanCount = response.xueYuanCount
          this.trialCanceledCount = response.trialCanceledCount || 0
          this.paidCanceledCount = response.paidCanceledCount || 0
          this.allCount = response.allCount
          this.loading = false
        })
    },
    /**
     * 订阅状态徽章颜色 + 文案。
     * version 由后端 UserTypeEnum.resolveVersion 派生：'new'/'old'/null
     * 仅在 type 是订阅档位（1/3/4/5/6/7/8/9/10/11）时叠加 (新版)/(旧版) 后缀。
     */
    computeStatus (type, renewStatus, version) {
      const data = { color: 'success', text: '免费' }
      const versionTag = version === 'new' ? '(新版)' : version === 'old' ? '(旧版)' : ''
      const renewTag = renewStatus === 0 ? '(到期不续费)' : ''

      if (type === 1 || type === 7) {
        data.color = 'danger'
        data.text = '付费pro' + versionTag + renewTag
      } else if (type === 3 || type === 6) {
        data.color = 'danger'
        data.text = '付费basic' + versionTag + renewTag
      } else if (type === 8) {
        data.color = 'danger'
        data.text = '付费autopilot' + versionTag + renewTag
      } else if (type === 4 || type === 10) {
        data.color = 'danger'
        data.text = '付费pro(试用期)' + versionTag
      } else if (type === 5 || type === 9) {
        data.color = 'danger'
        data.text = '付费basic(试用期)' + versionTag
      } else if (type === 11) {
        data.color = 'danger'
        data.text = '付费autopilot(试用期)' + versionTag
      } else if (type === 2) {
        data.color = 'warning'
        data.text = '学员'
      } else if (type === -1) {
        data.color = 'info'
        data.text = '未提交问卷'
      } else if (type === -2) {
        data.color = '#ff8c00'
        data.text = '试用期取消'
      } else if (type === -3) {
        data.color = '#9932CC'
        data.text = '不续费取消'
      }
      return data
    },
    formatSource (source) {
      switch (source) {
        case 0: return '未知'
        case 1: return '朋友介绍'
        case 2: return '领英'
        case 3: return '微信'
        case 4: return '小红书'
        case 5: return '推特'
        case 6: return 'Tiktok'
        case 7: return 'Facebook/Ins'
        case 8: return 'Reddit'
        case 9: return 'Google/Bing'
        case 10: return 'Others'
        default: return '无字段'
      }
    },
    formatRegisterTime: function (time) {
      if (!time) {
        return '-'
      }
      return formatTime(time)
    },
    formatPushTime: function (time) {
      if (time === 0) {
        return '-'
      }
      return formatTime(time)
    },
    formatPeriodTime: function (start, end) {
      return formatTime(start) + ' - ' + formatTime(end)
    },
    exportToCSV () {
      this.exportLoading = true
      const exportData = {
        pageSize: 10000,
        pageNumber: 1,
        keyword: this.keyword,
        inviterUid: this.inviterUid,
        startTime: this.startTime,
        endTime: this.endTime,
        subscriptionStatus: this.currentSubscriptionStatus,
        cancelLabel: this.currentCancelLabel,
      }

      openJobApi.listUser(exportData)
        .then(response => {
          this.generateCSV(response.userSimpleInfoList)
          this.exportLoading = false
          this.showToast('导出成功', {
            duration: 2000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
        })
        .catch(error => {
          this.exportLoading = false
          this.showToast('导出失败: ' + error.msg, {
            duration: 3000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
    },
    generateCSV (users) {
      const headers = ['用户名', '邮箱', '注册时间', '订阅状态', '用户来源']

      let csvContent = '﻿'
      csvContent += headers.join(',') + '\n'

      users.forEach(user => {
        const row = [
          user.nickname || '',
          user.email || '',
          this.formatRegisterTime(user.createTime),
          this.computeStatus(user.type, user.renewStatus, user.subscriptionVersion).text,
          this.formatSource(user.source),
        ]

        const escapedRow = row.map(field => {
          if (typeof field === 'string' && (field.includes(',') || field.includes('"') || field.includes('\n'))) {
            return '"' + field.replace(/"/g, '""') + '"'
          }
          return field
        })

        csvContent += escapedRow.join(',') + '\n'
      })

      this.downloadCSV(csvContent)
    },
    downloadCSV (csvContent) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)

        let filename = '用户数据'
        if (this.startTime && this.endTime) {
          const startDate = new Date(this.startTime * 1000).toISOString().split('T')[0]
          const endDate = new Date(this.endTime * 1000).toISOString().split('T')[0]
          filename += `_${startDate}_至_${endDate}`
        } else {
          const today = new Date().toISOString().split('T')[0]
          filename += `_${today}`
        }
        filename += '.csv'

        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
    },
  },
}

</script>
<style scoped>
.openjob-user-table /deep/ .va-data-table__table {
  table-layout: fixed;
  width: 100%;
}

.openjob-user-table /deep/ th,
.openjob-user-table /deep/ td {
  padding-left: 6px !important;
  padding-right: 6px !important;
  font-size: 12px;
}

.openjob-user-table /deep/ .openjob-user-table__nowrap {
  white-space: nowrap;
}

.openjob-user-table /deep/ .openjob-user-table__email {
  word-break: break-all;
}
</style>
